module.exports = __webpack_public_path__ + "static/media/29BDOS6.1b8f1896.jpg";